var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLineLeftDeco = function SvgLineLeftDeco(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 47 61",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.5 27.205 30.5 31",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeDasharray: "4 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m13 3.205 32 51",
    strokeWidth: 2,
    strokeLinecap: "square"
  })));
};
export { SvgLineLeftDeco as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNDcgNjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0yLjUgMjcuMjA1MUwzMyA1OC4yMDUxIiBzdHJva2U9IiIgIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgc3Ryb2tlLWRhc2hhcnJheT0iNCA0Ii8+CjxwYXRoIGQ9Ik0xMyAzLjIwNTA4TDQ1IDU0LjIwNTEiIHN0cm9rZT0iIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiLz4KPC9zdmc+Cg==";